import { truncateSelectedValues } from './utils'

export const getFormattedPriceRangeAndTags = (
  priceRange = '',
  tags = '',
  financeType = '',
) => {
  const filterValues = [priceRange, tags, financeType].filter(Boolean)

  return filterValues.length > 1
    ? truncateSelectedValues(filterValues, 4, 'and')
    : filterValues[0] || ''
}
